module.exports = __webpack_public_path__ + "img/featuredartist15 (7).7f25a409.jpg";